import { requestWrapper } from '@/utils/axiosInstance';

const API_PROFILE = `${process.env.VUE_APP_PROFILE_PREFIX}/api/v1`;

export default {
  async getUser() {
    return await requestWrapper(API_PROFILE, 'GET', '/user');
  },

  async auth(data) {
    return await requestWrapper(API_PROFILE, 'POST', '/login', null, data);
  },
};
